// Admin "view as dealer": an admin number logs in, picks any dealer and then
// sees the portal exactly as that dealer (the dealer session keys are swapped
// in; the admin's own session is kept under ADMIN_SESSION_KEY).

export const ADMIN_PHONES = ["7041520364", "9982959199", "9687292559"];

const ADMIN_SESSION_KEY = "adminSession"; // { phone, dealer, role, scope }
const VIEW_AS_KEY = "adminViewAs"; // { phone, firmName }

export const digits10 = (v) => String(v ?? "").replace(/\D/g, "").slice(-10);

export const isAdminPhone = (phone) => ADMIN_PHONES.includes(digits10(phone));

// Admin Panel is only for the ADMIN_PHONES numbers (not every sheet row with
// Type = Admin), and never while viewing the portal as a dealer.
export const canSeeAdminPanel = () =>
  isAdminPhone(localStorage.getItem("loginPhone")) && !getViewAs();

// NBD staff see only their own dealers (RETENTION FOR ALL → NBD EMAIL).
export const isStaffRole = (role) => String(role || "").trim().toLowerCase() === "nbd";

export function getAdminSession() {
  try {
    return JSON.parse(localStorage.getItem(ADMIN_SESSION_KEY) || "null");
  } catch {
    return null;
  }
}

export function getViewAs() {
  try {
    return JSON.parse(localStorage.getItem(VIEW_AS_KEY) || "null");
  } catch {
    return null;
  }
}

// Called right after the admin's / NBD's OTP is verified.
// scope: "all" (admin) | "nbd" (only that NBD's dealers).
export function startAdminSession(phone, dealer, role, scope = "all") {
  localStorage.setItem(ADMIN_SESSION_KEY, JSON.stringify({ phone: digits10(phone), dealer, role, scope }));
  localStorage.removeItem(VIEW_AS_KEY);
}

// Switch the session to `phone` (rows = that dealer's rows from the dealers
// sheet). firmsPayload = the same firms cache Login writes for a dealer.
export function viewAsDealer(phone, rows, firmsPayload) {
  const p = digits10(phone);
  const main = rows[0] || { "Contact No": p };
  const role = String(main.Type || "dealer").trim().toLowerCase() || "dealer";
  localStorage.setItem("dealer", JSON.stringify(main));
  localStorage.setItem("role", role === "admin" ? "dealer" : role);
  localStorage.setItem("loginPhone", p);
  localStorage.setItem(`firmsCache:v1:${p}`, JSON.stringify({ ts: Date.now(), payload: firmsPayload }));
  localStorage.setItem(
    VIEW_AS_KEY,
    JSON.stringify({ phone: p, firmName: String(main.Particulars || main["Firm Name"] || "").trim() })
  );
}

// Back to the admin's own session (before picking another dealer).
export function restoreAdminSession() {
  const s = getAdminSession();
  if (!s) return;
  localStorage.setItem("dealer", JSON.stringify(s.dealer || { phone: s.phone }));
  localStorage.setItem("role", s.role || "dealer");
  localStorage.setItem("loginPhone", s.phone);
  localStorage.removeItem(VIEW_AS_KEY);
}

export function clearAdminSession() {
  localStorage.removeItem(ADMIN_SESSION_KEY);
  localStorage.removeItem(VIEW_AS_KEY);
}
